import React from 'react';
import { useGeneralHooks } from '../../../../../Hooks/hooks';
import Button from '../../../../Button/button';
import { ButtonTypes } from '../../../../../Interfaces/componentTypes';
import { LogoutIcon } from '../../../../../Assets/Icons';
import styles from './logOut.module.scss';

interface IProps {
    onClose:()=>void
};

const LogOutDialog:React.FC<IProps> = ({onClose}) => {
    const {onLogout,t} = useGeneralHooks();

  return (
    <div className={styles.container}>
        <div className={styles.header}>
      <div>
      <img src={LogoutIcon} alt='SecureIcon' />
      <p>{t('Buttons.Log_Out')}</p>
      </div>
    </div>
    <div className={styles.body}>
        <p >
        {t('Home.User_Drawer.Logout_Text')}
        </p>
        <div className={styles.buttonsRow}>
        <Button
                type='button'
                buttonType={ButtonTypes.Secondary}
                title={t('Buttons.Cancel')}
                onClick={onClose}
            />
            <Button
                type='button'
                buttonType={ButtonTypes.Primery}
                title={t('Buttons.Log_Out')}
                onClick={()=>onLogout({isExpired:false})}
            />
        </div>
    </div>
    </div>
  )
}

export default LogOutDialog
